import { gql } from 'graphql.macro';
import { orgContactFragment } from './common';

export const transportOrderFragment = gql`
    fragment transportOrderFields on TransportOrder {
        _id
        clinic {
            _id
        }
        manualPackageCount
        actualPackageCount
        deadline
        status
        hasProblem
        serviceCode
        externalReference
        comment
        internalMessage
        transportDate
        transportProvider {
            channel
            externalId
            code
        }
        pickup {
            name
            countryCode
            streetAddress
            zipCode
            city
        }
        delivery {
            name
            countryCode
            streetAddress
            zipCode
            city
        }
        orders {
            _id
            orderId
            patient {
                personalIdentityNumber
                firstName
                lastName
            }
        }
        isSameDayDelivery
    }
`;

export const transportOrderAdminFragment = gql`
    fragment transportOrderAdminFields on TransportOrder {
        ...transportOrderFields
        lab {
            name
            contact {
                address {
                    street
                    postalCode
                    city
                    country
                }
            }
        }
        clinic {
            name
            contact {
                address {
                    street
                    postalCode
                    city
                    country
                }
            }
        }
    }
    ${transportOrderFragment}
`;

export const nShiftPartnerServiceAddonFragment = gql`
    fragment nShiftPartnerServiceAddonFields on NShiftPartnerServiceAddon {
        id
        description
    }
`;

export const nShiftPartnerServiceFragment = gql`
    fragment nShiftPartnerServiceFields on NShiftPartnerService {
        id
        description
        addons {
            ...nShiftPartnerServiceAddonFields
        }
    }
    ${nShiftPartnerServiceAddonFragment}
`;

export const nShiftShipmentWaybillFragment = gql`
    fragment nShiftShipmentWaybillFields on NShiftShipmentWaybill {
        _id
        receiverReference {
            _id
            name
        }
        orders {
            _id
            orderId
        }
        orderNo
        internalMessage
        manualPackageCount
        status
        createdAtNShift
        createdAt
        prints {
            id
            fileUrl
            type
        }
    }
`;

export const detailedNShiftShipmentWaybillFragment = gql`
    fragment detailedNShiftShipmentWaybillFields on NShiftShipmentWaybill {
        _id
        receiverReference {
            _id
            name
            organizationNumber
            contact {
                ...orgContactFields
            }
        }
        senderReference {
            _id
            name
            organizationNumber
            contact {
                ...orgContactFields
            }
        }
        orders {
            _id
            orderId
            patient {
                firstName
                lastName
                personalIdentityNumber
            }
        }
        orderNo
        internalMessage
        manualPackageCount
        status
        createdAtNShift
        createdAt
        shipDate
        prints {
            id
            fileUrl
            type
        }
    }
    ${orgContactFragment}
`;
